import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActionWithMoreInfoModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-confirm-comment-modal',
  templateUrl: './confim-with-comment-modal.component.html',
  styleUrls: ['./confim-with-comment-modal.component.scss']
})
export class ConfimWithCommentModalComponent implements OnInit {
  public comment = '';
  public commentRequested: string = null;
  public subject = '';
  public actionName = '';
  public recipients = '';
  hideCommentField = false;
  dialogInfoText: string = null;

  constructor(
    public dialogRef: MatDialogRef<ConfimWithCommentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ActionWithMoreInfoModel,
    protected toastService: ToastrService
  ) {}

  ngOnInit() {
    const additionalData = this.data.additionalData as {
      hideCommentField?: boolean;
      dialogInfoText?: string;
    };
    if (additionalData) {
      this.hideCommentField = additionalData.hideCommentField ?? false;
      this.dialogInfoText = additionalData.dialogInfoText ?? null;
    }
    this.actionName = this.data.actionName;
    this.recipients = this.data.recipients;
    this.subject = this.data.subject;
    this.commentRequested = this.data.commentRequested;
  }

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    if (!this.comment && this.commentRequested) {
      this.toastService.error('Bitte begründen Sie diese Aktion');
      return;
    }
    this.data.subject = this.subject;
    this.data.comment = this.hideCommentField ? '(ohne Kommentar)' : this.comment;

    this.dialogRef.close(this.data);
  }
}
